import React from 'react';
import { LinkElement } from '../../schema/link.schema';
import styles from '../../assets/css/link.module.css';

interface LinkComponentProps {
	element: LinkElement;
}

const LinkComponent: React.FC<LinkComponentProps> = ({ element }) => {
	const { href, text, tags } = element;

	if (tags.includes('BUTTON'))
		return (
			<div style={{ width: '100%' }}>
				<button className={styles['link-button']}>
					<a href={href}>{text}</a>
				</button>
			</div>
		);

	return (
		<div style={{ width: '100%' }}>
			{' '}
			<a href={href} className={styles['base-tag']}>
				{text}
			</a>
		</div>
	);
};

export default LinkComponent;
